import useUserStore from "../../store/useUserStore";

const WithPermission = ({ children, id }) => {
  const { permissions = null } = useUserStore();

  const permissionCheck = permissions?.hasOwnProperty(id) && permissions[id] === true;

  return permissionCheck ? children : null;
};

export default WithPermission;
